import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-hodal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDamageList = _resolveComponent("ConfirmationDamageList")!
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showConfirmation)
      ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
          key: 0,
          acceptTheme: "primary",
          rejectTheme: "return",
          titleText: "You confirmed the following (previously reported) damage is still present:",
          footerText: "Is this trailer still DOT compliant <em>and</em> safe to perform the load with?",
          acceptText: "Confirmed, DOT and safe.",
          rejectText: "No",
          onAccept: _ctx.acceptPrompt,
          onReject: _ctx.rejectPrompt,
          acceptDisabled: _ctx.isAssessmentTrailerDotExpired,
          disabled: _ctx.submitting,
          boldTitle: true
        }, {
          warning: _withCtx(() => [
            _createVNode(_component_ConfirmationDamageList, { trailerAssessmentResult: _ctx.trailerAssessmentResult }, null, 8, ["trailerAssessmentResult"])
          ]),
          _: 1
        }, 8, ["onAccept", "onReject", "acceptDisabled", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}